__turbopack_context__.v({
  "video_block": "VideoBlock-module-scss-module__yRBhvG__video_block",
  "video_wrapper": "VideoBlock-module-scss-module__yRBhvG__video_wrapper",
});
